import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "object-builder-client" */'object-builder-ui-client').then(mod => mod.default),
  LoadingComponent: () => null
});